<ng-container *ngIf="phxThumbnailSrc && !phxPreviewSrc; else thumbnailWithTooltip">
  <ng-container *ngTemplateOutlet="thumbnailTemplate"></ng-container>
</ng-container>

<ng-template #thumbnailWithTooltip>
  <div
    class="phx-table-cell-media-thumbnail"
    phx-tooltip
    [phxContent]="phxThumbnailSrc ? previewTpl : (phxMediaType === PHX_TABLE_CELL_MEDIA_TYPE.IMAGE ? 'Image not available' : 'Video not available') | phxTranslate"
    [phxTooltipOverlayClassName]="phxThumbnailSrc ? 'phx-table-cell-media-tooltip' : ''"
    [phxPaddingNone]="!!phxThumbnailSrc"
  >
    <ng-container *ngTemplateOutlet="thumbnailTemplate"></ng-container>
  </div>

  <!-- Preview template for tooltip -->
  <ng-template #previewTpl>
    <div class="phx-table-cell-media-preview">
      <img
        *ngIf="phxMediaType === PHX_TABLE_CELL_MEDIA_TYPE.IMAGE"
        [src]="phxPreviewSrc"
        [alt]="phxAltText"
        class="phx-table-cell-media-preview-image"
      />
      <video
        *ngIf="phxMediaType === PHX_TABLE_CELL_MEDIA_TYPE.VIDEO"
        [src]="phxPreviewSrc"
        autoplay
        muted
        class="phx-table-cell-media-preview-video"
      ></video>
    </div>
  </ng-template>
</ng-template>

<ng-template #thumbnailTemplate>
  <div class="phx-table-cell-media-thumbnail">
    <img *ngIf="phxThumbnailSrc" [src]="phxThumbnailSrc" [alt]="phxAltText" class="phx-table-cell-media-image" />

    <div *ngIf="!phxThumbnailSrc" class="phx-table-cell-media-placeholder">
      <i phx-icon [phxIcon]="ErrorTriangleIcon" [size]="24" color="currentColor"></i>
    </div>

    <div
      *ngIf="phxMediaType === PHX_TABLE_CELL_MEDIA_TYPE.VIDEO && phxThumbnailSrc"
      class="phx-table-cell-media-play-overlay"
    >
      <i phx-icon [phxIcon]="PlayFilledIcon" [size]="12" color="white"></i>
    </div>
  </div>
</ng-template>
